// @flow

import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.vollDamm',
  title: 'hardCoded.title.vollDamm',
  slug: 'hardCoded.slug.vollDamm',
  catalog: {
    title: 'hardCoded.catalog.title.vollDamm',
    catalogMedia,
    price: numberToCurrency('6.30'),
    color: '#13493e'
  }
}
